import { z } from "zod";

export const LoginSchema = z.object({
  email: z
    .string()
    .min(2, { message: "Invalid email." })
    .email({ message: "Invalid email format." })
    .endsWith("@nnpcgroup.com", {
      message: "Invalid Email format",
    }),
  password: z.string().min(8, {
    message: "Password must be at least 8 characters.",
  }),
});

export const ResetSchema = z
  .object({
    email: z
      .string()
      .min(2, { message: "Invalid email." })
      .email({ message: "Invalid email format." })
      .endsWith("@nnpcgroup.com", {
        message: "Invalid Email format",
      }),
    password: z
      .string()
      .min(8, { message: "Password must be at least 8 characters." }),
    confirmPassword: z.string(),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "Passwords don't match",
    path: ["confirmPassword"],
  });
